/**
 * 应用配置
 * 统一管理环境变量配置
 */

// API 配置
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 30000
}

// 调试配置
export const DEBUG_CONFIG = {
  ENABLED: import.meta.env.VITE_DEBUG === 'true',
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || 'warn'
}

// 环境标识
export const ENV = {
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE
}

export default {
  API_CONFIG,
  DEBUG_CONFIG,
  ENV
}
